import type { HTMLAttributes, ReactNode } from "react";
import { forwardRef } from "react";

import { cn } from "../lib/cn";

export type EpisodeDetailPlayerLayoutProps = HTMLAttributes<HTMLDivElement> & {
  footer?: ReactNode;
  scrollAreaClassName?: string;
};

export const EpisodeDetailPlayerLayout = forwardRef<
  HTMLDivElement,
  EpisodeDetailPlayerLayoutProps
>(function EpisodeDetailPlayerLayout(
  { children, className, footer, scrollAreaClassName, ...props },
  ref,
) {
  return (
    <div
      className={cn(
        "relative flex h-[calc(100dvh-80px)] min-h-0 flex-col text-white",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "-mx-5 flex-1 touch-pan-y overflow-y-auto overscroll-contain px-5",
          scrollAreaClassName,
        )}
        ref={ref}
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {children}
      </div>
      {footer}
    </div>
  );
});
